<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<{
  class?: HTMLAttributes["class"];
  sortable?: boolean;
  sorted?: "asc" | "desc" | false;
  onSort?: (event: MouseEvent) => void;
}>();
</script>

<template>
  <th
    data-slot="table-head"
    :class="
      cn(
        'bg-muted text-muted-foreground border-border h-10 border-t px-3 text-left align-middle font-semibold whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
        props.class,
        {
          'hover:text-primary/80 hover:bg-muted/50 cursor-pointer transition-colors': sortable,
          'text-primary': sorted,
        },
      )
    "
    @click="sortable && onSort ? onSort($event) : undefined"
  >
    <div :class="{ 'flex items-center': sortable }">
      <slot />
      <span
        v-if="sortable"
        class="flex items-center justify-center px-2 transition-transform duration-200"
        :class="{
          'text-primary': !!sorted,
          'rotate-180': sorted === 'asc',
        }"
      >
        <i class="fa-regular fa-chevron-down" />
      </span>
    </div>
  </th>
</template>
